import { useRef } from "react";

/**
 * 3D Tilt wrapper — niente dipendenze, solo CSS transform legate al mouse.
 * Wrappa il children e gli applica perspective + rotateX/Y al passaggio del mouse.
 */
export const Tilt3D = ({
  children,
  className = "",
  max = 8,
  scale = 1.015,
  glare = true,
  ...props
}) => {
  const ref = useRef(null);
  const glareRef = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const cx = (e.clientX - r.left) / r.width;
    const cy = (e.clientY - r.top) / r.height;
    const rx = (0.5 - cy) * (max * 2);
    const ry = (cx - 0.5) * (max * 2);
    el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg) scale(${scale})`;
    if (glareRef.current) {
      glareRef.current.style.background = `radial-gradient(360px circle at ${cx * 100}% ${cy * 100}%, rgba(212,175,55,0.18), transparent 55%)`;
      glareRef.current.style.opacity = "1";
    }
  };

  const onLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.transform =
      "perspective(900px) rotateX(0deg) rotateY(0deg) scale(1)";
    if (glareRef.current) glareRef.current.style.opacity = "0";
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`tilt-3d will-change-transform ${className}`}
      style={{
        transformStyle: "preserve-3d",
        transition: "transform 0.55s cubic-bezier(0.2, 0.8, 0.2, 1)",
      }}
      {...props}
    >
      {children}
      {glare && (
        <div
          ref={glareRef}
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 rounded-[inherit] opacity-0 transition-opacity duration-500"
        />
      )}
    </div>
  );
};

export default Tilt3D;
